<template>
  <Modal
    v-model="showManager"
    :title="name?'添加物委会主任':'添加管理员'"
    :mask-closable="false"
    width="600"
    @on-cancel="ManagerQuxiao"
  >
    <div class="box table-box">
      <div class="right-text">姓名</div>
      <AutoComplete
        v-model="autoValue"
        @on-search="searchManger"
        @on-select="selectAuto"
        :placeholder="name?'请输入物委会主任名称...':'请输入管理员名称...'"
      >
        <Option
          v-for="(item,index) in userlist"
          :value="index"
          :key="index"
        >{{ item.realName}}({{item.userName || '无昵称'}})</Option>
      </AutoComplete>
    </div>
    <div class="box table-box">
      <div class="right-text">头像</div>
      <div class="form-avatar">
        <img
          class="form-avatar_img"
          :src="imgArr && imgArr[0]&& imgArr[0].path || require('@/assets/images/default.png')"
          title="用户头像"
        />
        <div class="photoKuang">
          <i class="iconfont icon-bianji1 photo-bianji"></i>
        </div>
        <div class="uploadKuang">
          <upload-img
            :imgArr="imgArr"
            :fixedNumber="[1, 1]"
            :imgNumber="1"
            :imgWidth="80"
            :imgHeight="80"
            :isActive="true"
            :isEditorBox="true"
            @saveImg="saveImg"
          >
            <div style="height:80px;width:80px;margin-top:100px"></div>
          </upload-img>
        </div>
      </div>
    </div>
    <div class="box table-box">
      <div class="right-text">电话</div>
      <Input v-model="phoneNO" placeholder="请输入手机号..." />
    </div>
    <div slot="footer">
      <Button type="text" @click="ManagerQuxiao">取消</Button>
      <Button type="primary" @click="ManagerQueding">确定</Button>
    </div>
  </Modal>
</template>

<script>
import uploadImg from "../../../components/uploadImg";
export default {
  components: {
    uploadImg,
  },
  props: {
    oldshowManager: {
      //控制是否显示搜索弹窗
      type: Boolean,
      default: false,
    },
    passManager: null,
    name: "",
  },
  data() {
    return {
      showManager: false,
      userlist: [], //搜索弹窗中搜索结果
      autoValue: "",
      selectManager: "",
      phoneNO: "",
      id: "",
      valueChange: false,
      page: 1,
      imgArr: [],
    };
  },
  computed: {},
  methods: {
    // 取消按钮
    modalCancel() {
      this._initProp();
    },
    saveImg(data) {
      console.log(this.imgArr);
      this.imgArr.splice(0, 1, data);
      this.isActive = true;
    },
    _searchManger(value) {
      if (this.page != 1 || !this.id) this.valueChange = true;
      var that = this;
      var userName = value;
      var url = this.urlobj.allAdmin();
      var zoneIdList = [sessionStorage.zoneId];
      that
        .$post(url, {
          pageNum: 1,
          pageSize: 10,
          isManager: 0,
          zoneIdList,
          userName,
        })
        .then((res) => {
          that.page++;
          that.isData = false;
          var list = [];
          res.rows.map((item) => {
            list.push({
              headPicUrl: item.headPicUrl,
              realName: item.realName,
              userName: item.userName,
              unionId: item.unionId,
            });
          });
          that.userlist = list;
        });
    },
    selectAuto(value) {
      var autoValue = this.userlist[value];
      this.$nextTick(() => {
        this.autoValue = autoValue.realName || autoValue.userName; // 更新地点
        this.imgArr = [
          {
            id: 0,
            path: autoValue.headPicUrl,
          },
        ];
      });
      this.selectManager = autoValue;
    },
    // 初始化数据
    _initProp() {
      this.proTitle = "";
      this.modelInput = "";
      this.userlist = [];
      this.$emit("modalCancel");
    },
    // 显示 加载中
    _showSpin() {
      this.showSpin = true;
    },
    // 隐藏加载中
    _hideSpin() {
      this.showSpin = false;
    },
    ManagerQueding() {
      var that = this;
      var selectManager = "";
      console.log(this.valueChange);
      if (this.valueChange) {
        that.userlist.forEach((item) => {
          if (
            item.unionId == that.selectManager.unionId &&
            (item.realName == that.autoValue || item.userName == that.autoValue)
          ) {
            selectManager = item;
          }
        });
      } else {
        selectManager = this.selectManager;
      }
      console.log(selectManager);
      console.log(this.autoValue);
      // if (!selectManager) {
      //   that.$Message.warning("请选择管理员");
      //   return;
      // }
      var url = that.urlobj.saveAdmin();
      let data = {
        // unionIdList: [selectManager.unionId],
        userName: this.autoValue,
        headPicUrl: "",
        zoneId: sessionStorage.zoneId,
        officePhoneNO: parseInt(that.phoneNO),
        headPicUrl: this.imgArr[0] && this.imgArr[0].path || "",
        id: this.id,
      };
      if (selectManager) {
        data.unionId = selectManager.unionId;
        data.userName = selectManager.realName || selectManager.userName;
        // data.headPicUrl = selectManager.headPicUrl;
      }
      that.$post(url, data).then((res) => {
        this.page = 1;
        this.valueChange = false;
        if (res.isSucceed) {
          if (that.id) this.$Message.success("修改成功");
          else this.$Message.success("添加成功");
          that.$emit("addManagerSuccess", {
            headPicUrl: this.imgArr[0] && this.imgArr[0].path || "",
            realName: that.autoValue,
            unionId: selectManager.unionId || res.newPrimaryKeys.unionId,
            id: res.newPrimaryKeys.id,
            phoneNO: that.phoneNO,
          });
        }
      });
    },
    ManagerQuxiao() {
      this.$emit("quxiao");
    },
  },
  watch: {
    passManager(newValue, oldValue) {
      if (newValue.unionId) {
        this.id = newValue.id;
        this.phoneNO = newValue.phoneNO;
        this.autoValue = newValue.realName;
        this.selectManager = newValue;
      } else {
        this.phoneNO = "";
        this.autoValue = "";
        this.id = "";
        this.selectManager = "";
      }
    },
    oldshowManager(newValue, oldValue) {
      this.showManager = JSON.parse(JSON.stringify(this.oldshowManager));
    },
    valueChange(newValue, oldValue) {
      console.log("b变valuechange");
    },
  },
  mounted() {},
  created() {
    this.searchManger = this._.debounce(this._searchManger, 500);
  },
};
</script>
<style lang="less" scoped>
.modelInput {
  margin-top: 10px;
}
.searchcard-wrapper {
  position: relative;
  padding-top: 30px;
  display: flex;
  flex-wrap: wrap;
  height: 180px;
  overflow-y: scroll;
}
.search-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 150px;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  margin-right: 20px;
  margin-bottom: 30px;
  position: relative;
}
.img img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.search-name {
  margin-top: 10px;
  color: #4b4b4b;
  font-weight: 600;
}
.nodata {
  margin: 0 auto;
  padding-top: 40px;
}
.searchcard-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.searchcard-wrapper::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-thumb {
  height: 20px;
  border-radius: 10px;
  background-color: #ccc;
}
.select {
  border: 1px solid #ff7b44;
}
.xuanzhong-icon {
  position: absolute;
  top: -12px;
  right: -14px;
  height: 25px;
  width: 25px;
}

.table-box {
  align-items: center;
  margin-bottom: 30px;
}
.right-text {
  width: 70px;
  text-align: right;
  margin-right: 10px;
}
.form-avatar {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px solid #c7c7c7;
  border-radius: 50%;
  &:hover .photoKuang {
    display: flex;
  }
}
.form-avatar_img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.photoKuang {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  height: 80px;
  width: 80px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  .photo-bianji {
    color: #fff;
    font-size: 24px;
    cursor: pointer;
  }
}

/deep/ #uploads {
  top: 100px !important;
  height: 80px !important;
  // background: red;
}

.uploadKuang {
  position: absolute;
  top: 0;
  left: 0;
  height: 80px;
  width: 80px;
}
</style>

